import React from 'react';
import Scrollbar from 'react-smooth-scrollbar';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import {
  secondary1000,
  secondary800,
} from 'themes/colors';
import classNames from 'classnames';
import SidebarContent from './SidebarContent';
import { SidebarProps } from '../../../utils/prop-types/ReducerProps';


const styles = theme => ({
  iconRoot: {
    color: secondary800,
    width: '0.875rem',
    height: '0.875rem',
  },
  sidebar: {
    position: 'fixed',
    top: '0',
    left: '0',
    zIndex: '99',
    height: '100vh',
    width: '100%',
    transition: 'transform 0.3s, width 0.3s',
    transform: 'translateX(calc(-100% - 1.25rem))',
    backgroundColor: secondary1000,
    '& a': {
      display: 'block',
    },
    '@media screen and (min-width: 576px)': {
      width: '15rem',
      transform: 'translateX(0)',
    },
  },
  'sidebar--show': {
    transform: 'translate(0)',
  },
  'sidebar--collapse': {
    transform: 'translateY(-100%)',
    '@media screen and (min-width: 576px)': {
      width: '4rem',
      overflow: 'visible',
      transform: 'translateY(0)',
      '& $sidebar__scroll': {
        width: '4rem',
        overflow: 'hidden',
        transition: 'width 0.3s',
      },
    },
  },
  sidebar__back: {
    display: 'none',
    cursor: 'pointer',
    '@media screen and (min-width: 576px)': {
      color: theme.palette.secondary['800'],
      right: '-0.75rem',
      width: '1.5rem',
      height: '1.5rem',
      position: 'absolute',
      top: '1.25rem',
      boxShadow: theme.shadows[1],
      backgroundColor: theme.palette.secondary['0'],
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: 'none',
      zIndex: '1',
    },
  },
  sidebar__scroll: {
    '& > div': {
      height: '100%',
    },
  },
  'sidebar__wrapper--desktop': {
    display: 'none',
    '@media screen and (min-width: 576px)': {
      display: 'block',
      minHeight: '43.75rem',
      height: '100vh',
    },
  },
  'sidebar__wrapper--mobile': {
    height: 'calc(100vh - 5rem)',
    '@media screen and (min-width: 576px)': {
      display: 'none',
    },
  },
});

const Sidebar = ({
  changeToDark, changeToLight, changeSidebarVisibility,
  sidebar, classes,
}) => {
  const Icon = sidebar.collapse ? MenuRoundedIcon : CloseRoundedIcon;
  return (
    <div
      className={classNames(classes.sidebar, {
        [classes['sidebar--show']]: sidebar.show,
        [classes['sidebar--collapse']]: sidebar.collapse,
      })}
    >
      <button className={classes.sidebar__back} onClick={changeSidebarVisibility}>
        <Icon classes={{ root: classes.iconRoot }} />
      </button>
      <Scrollbar className={`${classes.sidebar__scroll} scroll`}>
        <div className={classes['sidebar__wrapper--desktop']}>
          <SidebarContent
            onClick={() => {}}
            changeToDark={changeToDark}
            changeToLight={changeToLight}
            collapsed={sidebar.collapse}
          />
        </div>
        <div className={classes['sidebar__wrapper--mobile']}>
          <SidebarContent
            onClick={changeSidebarVisibility}
            changeToDark={changeToDark}
            changeToLight={changeToLight}
            collapsed={sidebar.collapse}
          />
        </div>
      </Scrollbar>
    </div>
  );
};

Sidebar.propTypes = {
  sidebar: SidebarProps.isRequired,
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  changeSidebarVisibility: PropTypes.func.isRequired,
  classes: PropTypes.element.isRequired,
};

export default withStyles(styles)(Sidebar);
